export default __webpack_public_path__ + "c63a2047405ab2c6902bf6970a7f26f7.png";